import MainNavigation from './main-navigation';

export default MainNavigation;
export { MainNavigation };
